module.exports = __webpack_public_path__ + "media/images/crown-67844b687d9d2487ce4898c72784baa0.svg";